import { useContext } from 'react';

import { ViewportContext } from '../providers';

export const useViewportScroll = () => {
  const { scrollX, scrollY } = useContext(ViewportContext);
  return { scrollX, scrollY };
};
